import React, { useCallback, useState } from 'react';
import { BasicLayout } from '../../shared/layout';
import {
  ResetRequestTemplate,
  GotMailTemplate,
} from '../../modules/users/components';
import { useAppDispatch } from '../../shared/infra/redux';
import { ResetRequest } from '../../modules/users/infra/types/RequestPasswordReset.type';
import { requestPasswordReset } from '../../modules/users/redux/operators';
import { useNotificationCenter } from '../../shared/components/toast';

function PasswordResetRequestPage(): JSX.Element {
  const dispatch = useAppDispatch();
  const [isSuccessful, setIsSuccessful] = useState<boolean>(false);
  const { addNotification } = useNotificationCenter();

  const handleOnBackClick = () => {
    setIsSuccessful(false);
  };

  const onSubmisResetRequest = useCallback(
    async (resetRequest: ResetRequest) => {
      const resultAction = await dispatch(requestPasswordReset(resetRequest));
      if (requestPasswordReset.rejected.match(resultAction)) {
        addNotification(
          {
            title: 'Error',
            description: resultAction.payload
              ? resultAction.payload.message
              : 'Invalid Email',
          },
          {
            variant: 'ERROR',
          },
        );
      }

      if (requestPasswordReset.fulfilled.match(resultAction)) {
        setIsSuccessful(true);
      }
    },
    [addNotification, dispatch],
  );

  return (
    <BasicLayout>
      <div className='flex items-center justify-center flex-1 w-2/3 lg:w-1/2 xl:w-1/3 mx-auto mt-16'>
        {isSuccessful ? (
          <GotMailTemplate onBack={handleOnBackClick} />
        ) : (
          <ResetRequestTemplate onSubmit={onSubmisResetRequest} />
        )}
      </div>
    </BasicLayout>
  );
}

export default PasswordResetRequestPage;
